import { render } from "./v-modal.vue?vue&type=template&id=225f35f8&scoped=true"
import script from "./v-modal.vue?vue&type=script&lang=js"
export * from "./v-modal.vue?vue&type=script&lang=js"

import "./v-modal.vue?vue&type=style&index=0&id=225f35f8&scoped=true&lang=css"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225f35f8"]])

export default __exports__